export const GameConfig = {
    room: {
        width: 320,
        height: 122,
        scrollSpeed: 400
    },
    player: {
        x: 180,
        yOffset: 30,
        autoMoveSpeed: 200,
        startStats: {
            maxHealth: 150,
            health: 150,
            attack: 20,
            speed: 4.0,
            crit: 5,
            gold: 0
        }
    },
    monster: {
        x: 120,
        yOffset: 30,
        baseStats: {
            maxHealth: 40,
            health: 40,
            attack: 8,
            speed: 3.0,
            crit: 0,
            gold: 50
        },
        loopStats: {
            maxHealth: 8,
            health: 8,
            attack: 2,
            speed: 0.1,
            crit: 0.5,
            gold: 2
        },
        fightStats: {
            maxHealth: 0,
            health: 0,
            attack: 0,
            speed: 0.0,
            crit: 0,
            gold: 0
        },
        applyFightStatsForBoss: false,
        simpleStatMultipliers: {
            maxHealth: 0.75,
            health: 0.75,
            attack: 1.5,
            speed: 1.0,
            crit: 1.0,
            gold: 1.0
        },
        bossStatMultipliers: {
            maxHealth: 1.75,
            health: 1.75,
            attack: 1.5,
            speed: 1.0,
            crit: 1.0,
            gold: 2.0
        },
        maxSpeed: 5.0,
        maxMultipliedSpeed: Infinity,
    },
    fight: {
        targetSpeedValue: 10.0
    },
    sanctuary: {
        healPercent: 30,
    },
    forge: {
        gold: 250,
        attack: 2,
        health: 8,
        speed: 0.1,
        crit: 0.2,
        multirepeat: true,
        healOnHealthIncrease: true,
        maxSpeed: 8.0
    }
}; 